import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import SkeletonComponent from 'UiKit/skeleton';
import FieldDescription from 'View/host/component/field-description';
import { Iteration } from 'Component/others';

import styles from './styles.module.css';

export const SkeletonDetailOverview = () => {
  const { t } = useTranslation('host-schedule');
  return (
    <Box className={styles['skeleton-detail-overview__container']} data-testid="skeleton-detail-overview__container">
      <Box className={styles['head__section']}>
        <SkeletonComponent height="16px" width="80%" mb="8px" />
        <SkeletonComponent height="17px" width="131px" mb="6px" />
        <SkeletonComponent height="14px" width="140px" mb="8px" />
      </Box>

      <Box className={styles['content__section']}>
        <FieldDescription label={t('card.account')} isLoading skeletonWidth="80%" />
        <FieldDescription label={t('card.platform')} isLoading skeletonWidth="126px" />
        <FieldDescription label={t('card.host')} isLoading skeletonWidth="90px" />
        <FieldDescription label={t('card.operator')} isLoading skeletonWidth="113px" />
        <FieldDescription label={t('card.room_studio_name')} isLoading skeletonWidth="87px" />
      </Box>
    </Box>
  );
};

export const SkeletonAchievementLive = () => {
  return (
    <Box className={styles['skeleton-achievement-live__container']} data-testid="skeleton-achievement-live__container">
      <SkeletonComponent mb="10px" height="16px" width="111px" />

      <Iteration
        items={[1, 2, 3]}
        render={(num) => (
          <Box className={styles['card-achievement-live__container']} key={num}>
            <Box className={styles['head__section']}>
              <SkeletonComponent height="12px" width="160px" />
            </Box>

            <Box className={styles['content__section']}>
              <SkeletonComponent height="10px" width="130px" mb="6px" />
              <SkeletonComponent height="10px" width="270px" mb="4px" />
              <SkeletonComponent height="10px" width="200px" />
            </Box>

            <Box className={styles['footer__section']}>
              <SkeletonComponent height="12px" width="12px" />
              <SkeletonComponent height="10px" width="258px" />
            </Box>
          </Box>
        )}
      />
    </Box>
  );
};

export const SkeletonButtonReschedule = () => {
  return (
    <Box className={styles['skeleton-button-change-schedule__container']} data-testid="skeleton-button-change-schedule__container">
      <Box className={styles['skeleton-button-change-schedule__button']}></Box>
    </Box>
  );
};
